import React, { useCallback } from 'react';
import { Text, ControlLink } from '@moda/om';
import { useUser, getUserFromCookies } from '../../hooks/useUser';
import { useAuthModal } from '../../hooks/useAuthModal';

export const AccountEmailInUseLink: React.FC = () => {
  const { openAuthModal } = useAuthModal();
  const {
    user: { isLoggedIn }
  } = useUser();
  const { isMember, email } = getUserFromCookies();

  const handleClick = useCallback(() => {
    openAuthModal({ defaultValues: { signInEmail: email || undefined } });
  }, [openAuthModal, email]);

  return (
    (!isLoggedIn && isMember && (
      <Text>
        There is a Moda Operandi account associated with this email.{' '}
        <ControlLink onClick={handleClick}>SIGN IN</ControlLink> to use your saved address and
        payment methods.
      </Text>
    )) ||
    null
  );
};
